import './Link-948b910e.css';

var classes = {"Link":"prc-Link-Link-85e08"};

export { classes as default };
